  import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { getUser, getUserByEntityType } from "http/fundLync/user.helper";
import { getDeal, getDealInfo, getEntityWiseDeal } from "http/fundLync/deal.helper";
import { addTask, getAllEntity, getEntity, getOneEntity, sendReminder} from "http/fundLync/entityAndAddress.helper";
import ToastDialog from "components/Common/ToastDialog";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { callGetCIUser } from "http/fundLync/dealFinancier";
import { decryptedValue } from "common/utility";


const AddTaskForm = ({ onSchedule, onCancel }) => {
  const navigate = useNavigate();
  const [typeList, setTypeList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [reminderList, setReminderList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [entity, setEntity] = useState([]);
  const [showNestedDropdown, setShowNestedDropdown] = useState(false);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [selecteddealId, setSelecteddealId] = useState(null);
  const [selectedNestedDropdownData, setSelectedNestedDropdownData] = useState([]);
  const [userList, setUserList] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [entityName, setEntityName] = useState('');
  const [dealName, setDealName] = useState('');
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const currentDate = new Date().toISOString().split("T")[0];
  const urlParams = new URLSearchParams(window.location.search);
  const [encodedId, setEncodedId] = useState('')
  const [encodedIdDeal, setEncodedIdDeal] = useState('')
  const [ entityId, setEntityId] = useState('')
  const [ dealId, setDealId] = useState('')
  const [dealAuthorList, setDealAuthorList] = useState([]);
  const [selectedDealAuthor, setSelectedDealAuthor] = useState("");
  const [hasOpenedBefore, setHasOpenedBefore] = useState(true);

  let userDetails = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const entityName = queryParams.get('entityName');
    if (entityName) {
      setEntityName(entityName);
    }
    const dealName = queryParams.get('dealName');
    if (dealName) {
      setDealName(dealList);
    }
    const userDetails = decryptedValue(localStorage.getItem("user"));
    const type = queryParams.get('type');
    if (type) {
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("entityId"))
        setEncodedIdDeal(urlParams.get("id"))
        setDealId(atob(encodedIdDeal))
        setEntityId(encodedId)
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
    }else{
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
    }
    

  }, [location.search, entityId, encodedId, dealId, encodedIdDeal]);

  const user = decryptedValue(localStorage.getItem("user"));
  useEffect(() => {
      callGetCIUser()
      .then((res) => {
        setDealAuthorList(res.data.rows)
      })
      .catch((error) => {})
    //Fetching Task Type
    getDropDownList({ dropdownName: "Task_Type" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Task_Type")
            ?.dropdownValues || [];
            setTypeList(dropdownValues);
      })
      .catch((error) => {"Error fetching data", error });


    //Fetching Task Status
    getDropDownList({ dropdownName: "Task_Status" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Task_Status")
            ?.dropdownValues || [];
            setStatusList(dropdownValues);
      })
      .catch((error) => {"Error fetching data", error });


      //Fetching Task Priority
      getDropDownList({ dropdownName: "Task_Priority" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Task_Priority")
            ?.dropdownValues || [];
            setPriorityList(dropdownValues);
      })
      .catch((error) => {"Error fetching data", error });


      //Fetching Task Reminder
      getDropDownList({ dropdownName: "Reminder" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Reminder")
            ?.dropdownValues || [];
            setReminderList(dropdownValues);
      })
      .catch((error) => {"Error fetching data", error });

    if(encodedIdDeal){
      getDealInfo({ id : dealId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setDealName(response.data.dealName)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }
    if(encodedId){
      getOneEntity({ entityId : entityId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setEntity(response.data[0].entityName);
        }
      })
      .catch((error) => {
        console.log(error)
      })
      
    }else{
      let totalValues;
        getEntity({user})
         .then((response) =>{
          totalValues = response.data.totalItems; 
            getEntity({limit:totalValues, user, columnName : "entityName", sortingOrder :"asc"})
            .then((response) => {
                setEntityList(response?.data?.data);
            })
            .catch((error) => {
              console.log(error)
            })
         }) 
        .catch((error) => {
          console.log(error)
        })
    }
     
    if(encodedId){
      getEntityWiseDeal({ entityId: entityId })
      .then((response) => {
        if (response?.data?.rows.length > 0) {
          setDealList(response.data.rows);
        } else {
          setDealList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
   }

  }, [entityId, encodedId, encodedIdDeal]);

  const initialValues = {
    entity: "",
    deal: "",
    taskName: "",
    type: "",
    description: "",
    status: "",
    priority: "",
    dueDate: "",
    dueTime: "",
    reminder: "",
    assignedTo: ''
  };

  //Form Validation
  const validationSchema = Yup.object({
    // entity: Yup.string().required("Entity Name is required"),
    entity: Yup.string().when([], {
      is: () => !encodedId,
      then: Yup.string().required("Entity is required"),
      otherwise: Yup.string(),
    }),
    deal: Yup.string(),
    taskName: Yup.string().required("Task Name is required"),
    type: Yup.string().required("Type is required"),
    description: Yup.string(),
    status: Yup.string().required("Status is required"),
    priority: Yup.string(),
    dueDate: Yup.date().required("Due Date is required"),
    dueTime: Yup.string().required("Due time is required"),
    reminder: Yup.string().required("Reminder is required"),
  });

   // Handling Form Submit
  const handleSubmit = (values) => {
    
    // const selectedEntityId = values.entity;
    
    const newtask = {
      entityId: selectedEntityId || entityId,
      dealId: selecteddealId || dealId,
      name: values.taskName,
      type: values.type,
      description: values.description || '',
      status: values.status,
      priority: values.priority || '',
      dueDate: values.dueDate || '',
      dueTime: values.dueTime || '',
      reminder: values.reminder || '',
      assignedTo: values.assignedTo || '',
    };
    addTask(newtask)
        .then((response) => {
          if (response) {
              setToastInfo({
                message: "Task Created Successfully",
                showToast: true,
                role: "success",
              });
              setTimeout(() => {
                if ((encodedId && entityName) || (!encodedId && !entityName)) {
                  window.history.back();
                } else {
                  onSchedule();
                  handleCancel();
                }
              }, 1000);
          } 
          else {
            console.log("Some error occured");
          }
        })
        .catch((error) => {
          console.log(error);
        })
  };
  
  const handleDealChange = (e) => {
    const selecteddealId = e.target.value;
      setSelecteddealId(selecteddealId);
  }
  const handleEntityChange = (e) => {
    const selectedEntityId = e.target.value;
      setSelectedEntityId(selectedEntityId);

    getEntityWiseDeal({ entityId: selectedEntityId || entityId })
      .then((response) => {
        if (response?.data?.rows.length > 0) {
          setDealList(response.data.rows);
          setShowNestedDropdown(true);
        } else {
          setDealList([]);
          setShowNestedDropdown(false);
        }
      })
      .catch((error) => {
        setDealList([]);
        setShowNestedDropdown(false);
      });
    
  };

  // For multi select
  const handleInputChangeForDealAuthor = (value) => {
    callGetCIUser()
      .then((response) => {
        setDealAuthorList(response.data.rows)
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOptionChange = (value) => {
    setInputValue(value);
  };
 
  //Handling Form Cancel
  const handleCancel = () => {
    onCancel();
    //navigate(-1);
  };
  const handleEntityChangeDealAuthor = (option) => {
    setSelectedDealAuthor(option);
    validationSchema.setFieldValue("assignedTo", option.value);
  };
  return (
    <React.Fragment>
      <div className="page-content" style={encodedId === null || entityName ? {} : {marginTop: "-80px"}}>
        <Container fluid>
        {encodedId === null || entityName && <Breadcrumbs title="Add Task" />}
          <Row className={(encodedId && entityName) || (!encodedId && !entityName) ? "vertical-scroll" : ""}  >
            <Col xs="12">
              <div>
                <div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      setFieldValue,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <h5 style={{ marginTop: "1%", color: "#21aa47" }}>Task Details</h5>
                        {encodedId ? (
                          <Row className="mb-3">
                            <Col sm="6">
                              <Label className="form-label mt-4">Entity</Label>
                              <Input
                                type="text"
                                name="entity"
                                id="entity"
                                value={entity}
                                disabled
                              />
                            </Col>
                            {encodedIdDeal ? (
                              <Col sm="6">
                                <Label className="form-label mt-4">Deal</Label>
                                <Input
                                  type="text"
                                  name="entity"
                                  id="entity"
                                  value={dealName}
                                  disabled
                                />
                              </Col>
                            ) :
                              dealList?.length > 0 && (
                                <Col sm="6">
                                <Label className="form-label mt-4">Select Deal</Label>
                                <Select
                                  name="deal"
                                  options={dealList.map((deal) => ({
                                    value: deal.id,
                                    label: deal.dealName,
                                  }))}
                                  onChange={(selectedOption) => {
                                    const selectedValue = selectedOption ? selectedOption.value : "";
                                    setFieldValue("deal", selectedValue);
                                    handleDealChange({ target: { value: selectedValue } });
                                  }}
                                  value={
                                    values.deal
                                      ? {
                                        value: values.deal,
                                        label: dealList.find((deal) => deal.id === values.deal).dealName,
                                      }
                                      : null
                                  }
                                  classNamePrefix="select"
                                  className={touched.deal && errors.deal ? "is-invalid" : ""}
                                  isSearchable={true}
                                  isClearable={true}
                                />
                                {touched.deal && errors.deal && (
                                  <FormFeedback className="d-block">{errors.deal}</FormFeedback>
                                )}
                              </Col>
                              )
                            }
                          </Row>
                        ) : (

                          <Row className="mb-3">
                            <Col sm="6">
                              <Label className="form-label mt-4">Select Entity*</Label>
                              <Select
                                name="entity"
                                options={entityList.map((item) => ({
                                  value: item.id,
                                  label: item.entityName,
                                }))}
                                onChange={(selectedOption) => {
                                  const selectedValue = selectedOption ? selectedOption.value : "";
                                  setFieldValue("entity", selectedValue);
                                  handleEntityChange({ target: { value: selectedValue } });
                                }}
                                value={
                                  values.entity
                                    ? {
                                      value: values.entity,
                                      label: entityList.find((item) => item.id === values.entity).entityName,
                                    }
                                    : null
                                }
                                classNamePrefix="select"
                                className={touched.entity && errors.entity ? "is-invalid" : ""}
                                isSearchable={true}
                                isClearable={true}
                              />
                              {touched.entity && errors.entity && (
                                <FormFeedback className="d-block">{errors.entity}</FormFeedback>
                              )}
                            </Col>

                            {showNestedDropdown && (
                              <Col sm="6">
                                <Label className="form-label mt-4">Select Deal</Label>
                                <Select
                                  name="deal"
                                  options={dealList.map((deal) => ({
                                    value: deal.id,
                                    label: deal.dealName,
                                  }))}
                                  onChange={(selectedOption) => {
                                    const selectedValue = selectedOption ? selectedOption.value : "";
                                    setFieldValue("deal", selectedValue);
                                    handleDealChange({ target: { value: selectedValue } });
                                  }}
                                  value={
                                    values.deal
                                      ? {
                                        value: values.deal,
                                        label: dealList.find((deal) => deal.id === values.deal).dealName,
                                      }
                                      : null
                                  }
                                  classNamePrefix="select"
                                  className={touched.deal && errors.deal ? "is-invalid" : ""}
                                  isSearchable={true}
                                  isClearable={true}
                                />
                                {touched.deal && errors.deal && (
                                  <FormFeedback className="d-block">{errors.deal}</FormFeedback>
                                )}
                              </Col>
                            )}
                          </Row>
                        )}
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label className="form-label mt-4">Task Name*</Label>
                            <Input
                              type="text"
                              name="taskName"
                              placeholder="Enter Task Name"
                              onChange={handleChange}
                              value={values.taskName}
                              invalid={touched.taskName && !!errors.taskName}
                            />
                            {touched.taskName && errors.taskName && (
                              <FormFeedback>{errors.taskName}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="6">
                            <Label className="form-label mt-4">Type*</Label>
                            <Input
                              type="select"
                              name="type"
                              onChange={handleChange}
                              value={values.type}
                              invalid={touched.type && !!errors.type}
                            >
                              <option value="" label="Select type" disabled/>
                              {typeList.map((type) => (
                                <option key={type.id} value={type.dropdownValue}>
                                  {type.displayName}
                                </option>
                              ))}
                            </Input>
                            {touched.type && errors.type && (
                              <FormFeedback>{errors.type}</FormFeedback>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="12">
                            <Label className="form-label mt-4">Description</Label>
                            <Input
                              type="textarea"
                              name="description"
                              placeholder="Enter Task Description"
                              onChange={handleChange}
                              value={values.description}
                              cols="50"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col sm="4">
                            <Label className="form-label mt-4">
                              Assign User
                            </Label>
                            <Select
                              options={dealAuthorList.map((option, index) => ({
                                label: `${option.firstName + " " + option.lastName}`,
                                value: option.id,
                              }))}
                              className={`select-dropdown ${touched.assignedTo &&
                                errors.assignedTo
                                ? "is-invalid"
                                : ""
                                }`}
                              // isDisabled={!selectedDealType || isDisableEntity}
                              name="assignedTo"
                              id="assignedTo"
                              placeholder={"select user"}
                              value={selectedDealAuthor}
                              onInputChange={(e) => {
                                handleInputChangeForDealAuthor
                              }}
                              onMenuOpen={(e) => {
                                hasOpenedBefore ? handleInputChangeForDealAuthor("") : null;
                                setHasOpenedBefore(false);
                              }}
                              onChange={(selectedOption) => {
                                setSelectedDealAuthor(selectedOption);
                                setFieldValue("assignedTo", selectedOption.value)
                              }}
                            />
                            {touched.assignedTo &&
                              errors.assignedTo && (
                                <FormFeedback>
                                  {errors.assignedTo}
                                </FormFeedback>
                              )}
                          </Col>
                          <Col sm="4">
                            <Label className="form-label mt-4">Status*</Label>
                            <Input
                              type="select"
                              name="status"
                              placeholder="Enter Task Name"
                              onChange={handleChange}
                              value={values.status}
                              invalid={touched.status && !!errors.status}
                            >
                              <option value="" label="Select Status" disabled />
                              {statusList.map((status) => (
                                <option key={status.id} value={status.dropdownValue}>
                                  {status.displayName}
                                </option>
                              ))}
                            </Input>
                            {touched.status && errors.status && (
                              <FormFeedback>{errors.status}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="4">
                            <Label className="form-label mt-4">Priority</Label>
                            <Input
                              type="select"
                              name="priority"
                              onChange={handleChange}
                              value={values.priority}
                            >
                              <option value="" label="Select Priority" disabled />
                              {priorityList.map((priority) => (
                                <option key={priority.id} value={priority.dropdownValue}>
                                  {priority.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>


                        <Row className="mb-3">
                          <Col sm="3">
                            <Label className="form-label mt-4">Due Date*</Label>
                            <Input
                              type="date"
                              name="dueDate"
                              onChange={handleChange}
                              value={values.dueDate}
                              invalid={touched.dueDate && !!errors.dueDate}
                              min={currentDate}
                            />
                            {touched.dueDate && errors.dueDate && (
                              <FormFeedback>{errors.dueDate}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="3">
                            <Label className="form-label mt-4">Time*</Label>
                            <Input
                              type="time"
                              name="dueTime"
                              onChange={handleChange}
                              value={values.dueTime}
                              invalid={touched.dueTime && !!errors.dueTime}
                            />
                            {touched.dueTime && errors.dueTime && (
                              <FormFeedback>{errors.dueTime}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="6">
                            <Label className="form-label mt-4">Reminder*</Label>
                            <Input
                              type="select"
                              name="reminder"
                              onChange={handleChange}
                              value={values.reminder}
                              invalid={touched.reminder && !!errors.reminder}
                            >
                              <option value="" label="Select Reminder" disabled />
                              {reminderList.map((reminder) => (
                                <option key={reminder.id} value={reminder.dropdownValue}>
                                  {reminder.displayName}
                                </option>
                              ))}
                            </Input>
                            {touched.reminder && errors.reminder && (
                              <FormFeedback>{errors.reminder}</FormFeedback>
                            )}
                          </Col>
                        </Row>

                        <div className="d-flex justify-content-end">
                          <Button
                            type="submit"
                            style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
                            className="me-2"
                          >
                            Add
                          </Button>
                          <Button type="button" 
                            onClick={handleCancel}
                            outline
                            >
                            Cancel
                          </Button> 
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};
 
AddTaskForm.defaultProps = {
  onSchedule: () => {
    window.history.back();
  },
  onCancel: () => {
    window.history.back();
  },
};

export default AddTaskForm;
